export const buildGeneratedValues = {
	timeStamp: 'Nov 5th 26, 13:45'
};
